import { useTranslation } from "react-i18next";

/**
 * Returns the duration formatted according to the user's locale.
 *
 * @param durationInSeconds - The duration in seconds.
 * @returns - The formatted number.
 */
export function useFormattedDuration(durationInSeconds?: number | string) {
  const { i18n } = useTranslation();
  if (typeof durationInSeconds === "string" || durationInSeconds === undefined) {
    return "---";
  }
  if (durationInSeconds < 60) {
    return `${durationInSeconds} ${i18n.t(`second${durationInSeconds > 1 ? "s" : ""}`)}`;
  } else if (durationInSeconds < 3600) {
    const minutes = Math.floor(durationInSeconds / 60);
    return `${minutes} ${i18n.t(`time.minute${minutes > 1 ? "s" : ""}`)}`;
  } else if (durationInSeconds < 86400) {
    const hours = Math.floor(durationInSeconds / 3600);
    return `${hours} ${i18n.t(`time.hour${hours > 1 ? "s" : ""}`)}`;
  } else {
    const days = Math.floor(durationInSeconds / 86400);
    return `${days} ${i18n.t(`time.day${days > 1 ? "s" : ""}`)}`;
  }
}
